import { Divider, List, Box, IconButton, useMediaQuery } from '@mui/material';
import { lighten, useTheme } from '@mui/material/styles';
import TheGuarantorsLogo from '@/assets/images/updated-logo-white.png';
import TheGuarantorsLogoCompact from '@/assets/images/logo-compact-white.svg';
import useMenu from '../../useMenu';
import { theme } from '@theguarantors/tg-package-material-ui';
import { ArrowLeftOutlined, ArrowRightOutlined } from '@mui/icons-material';
import MenuContent from '@/appWrapper/MenuContent/V2';
import { Transition } from 'react-transition-group';

const SideMenu = () => {
  const { menuOpen, openMenu, closeMenu } = useMenu();
  const muiTheme = useTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down('sm'));
  const themeAsAny = theme as any;
  const toggleMenu = () => {
    if (menuOpen) {
      closeMenu();
    } else {
      openMenu();
    }
  };

  const getSideMenuMinHeight = (elementId: string): string => {
    const element = document.getElementById(elementId);
    const numberOfFirstColumnIcons = element ? element.children.length : 0;
    return `${(numberOfFirstColumnIcons + 1) * 50}px`;
  };

  const sideMenuMinHeight = getSideMenuMinHeight('firstColumnIcons');

  return (
    <Transition in={menuOpen} timeout={10}>
      {(state) => (
        <Box
          id="sideMenu"
          sx={{
            height: '100vh',
            position: 'sticky',
            top: 0,
            display: isMobile ? 'none' : 'flex',
            zIndex: 1000,
            transition: 'max-width 300ms linear', // Smooth animation for max-width
            maxWidth: state === 'entered' ? '100%' : '72px', // Dynamically adjust max-width
          }}
        >
          <List
            sx={{
              boxShadow: '0px 6px 30px 5px rgba(0, 0, 0, 0.12)',
              backgroundColor: themeAsAny.palette.blue.main,
              '@media (max-height: 580px)': {
                minHeight: sideMenuMinHeight,
              },
              color: 'white',
              zIndex: 10,
              '& .MuiSvgIcon-root': { fill: 'white' },
              padding: 0,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              width: '100%',
            }}
          >
            <Box
              textAlign="center"
              sx={{
                padding: '24px 16px',
                // width: '100%',
                width: 'calc(100% - 28px)',
                height: '24px',
                borderBottom: `1px solid ${themeAsAny.palette.midnightGrey[800]}`,
                whiteSpace: 'nowrap',
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <Box
                sx={{
                  width: menuOpen ? '180px' : '40px',
                  transition: 'all 0.3s linear',
                }}
              >
                {menuOpen ? (
                  <img height="24px" width="180px" src={TheGuarantorsLogo} alt="TheGuarantors" />
                ) : (
                  <img
                    height="24px"
                    width="40px"
                    src={TheGuarantorsLogoCompact}
                    alt="TheGuarantors"
                  />
                )}
              </Box>
            </Box>

            <Divider sx={{ borderBottom: `1px solid ${themeAsAny.palette.midnightGrey.main}` }} />

            <IconButton
              sx={{
                padding: 0,
                outline: `1px solid ${themeAsAny.palette.midnightGrey[800]}`,
                backgroundColor: themeAsAny.palette.blue.main,
                borderRadius: '6px',
                margin: '-14px -14px -12px auto',
                ':hover': {
                  backgroundColor: lighten(themeAsAny.palette.blue.main, 0.2),
                },
              }}
              aria-label="toggle side menu"
              onClick={toggleMenu}
            >
              {menuOpen ? <ArrowLeftOutlined /> : <ArrowRightOutlined />}
            </IconButton>

            <MenuContent menuOpen={menuOpen} />
          </List>
        </Box>
      )}
    </Transition>
  );
};

export default SideMenu;
